export default __webpack_public_path__ + "static/register-bg-f9541ce0b9b5270f879e06d73c5fa0d5.png";